/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import useToast from '../../customHooks/useToast';
import ExportIcon from '../../svgs/ExportIcon';
// import Buttons from '../Buttons';
import Dropdown from '../Dropdown';
import StyledButton from '../StyledButton';
import './ExportPDF.scss';

const ExportPDF = ({
  exportObj, disableExport, name, boxShadow, padding, icon,
}: { exportObj?: any, disableExport?:boolean, name?:string, boxShadow?:string, padding?:string, icon?:any }) => {
  const [showExportList, setShowExportList] = React.useState(false);
  const [exportIsLoading, setExportIsLoading] = React.useState('');
  const exportsRef = useRef<HTMLDivElement>(null);
  const Toast = useToast();
  const handleClick = (e) => {
    if (exportsRef?.current?.contains(e.target)) {
      return;
    }
    setShowExportList(false);
  };
  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  const handleExport = async ({ value }) => {
    if (exportIsLoading) {
      Toast.error('Please wait while the previous export is in progress');
      return;
    }
    setExportIsLoading(value);
    await exportObj?.handleExport?.(value);
    setExportIsLoading('');
  };

  return (
    <div ref={exportsRef} className="exports-pdf">
      {/* <Buttons
        // name="Export"
        className="exports-pdf-btn"
        Icon={ExportIcon}
        onClick={() => {
          if (disableExport) return;
          setShowExportList((prev) => !prev);
        }}
        optional="filter-button"
        disabled={disableExport}
      /> */}
      <StyledButton
        disabled={disableExport}
        onClick={() => {
          if (disableExport) return;
          setShowExportList((prev) => !prev);
        }}
        icon={icon || <ExportIcon />}
        name={name}
        border="none"
        padding={padding || '0px'}
        backgroundColor="#f9f9f9"
        boxShadow={boxShadow}
        fontSize="10px"
        fontWeight="600"
        borderRadius="8px"

      />
      <div className={`exports-dropdown ${showExportList ? '' : 'exports-pdf-hidden'}`}>
        <Dropdown onClick={handleExport} options={[{ label: (exportIsLoading === 'pdf') ? 'Downloading...' : 'Download as .PDF', value: 'pdf' }, { label: exportIsLoading === 'csv' ? 'Downloading...' : 'Download as .CSV', value: 'csv' }]} />
      </div>
    </div>
  );
};

export default ExportPDF;
